// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__PDb8J","left":"StickyBox_left__3CzBq","right":"StickyBox_right__2-d5Y"};